import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket!: WebSocket;
  private cmd = {
    join: '/join '
  };

  constructor(private router: Router, private http: HttpClient) { }

  connect(user: string, wsUrl: string, redirectUrl: string = ''): void {
    this.socket = new WebSocket(wsUrl);

    this.socket.onopen = () => {
      this.socket.send(this.cmd.join + user);
    };

    this.socket.onmessage = (evt) => {
      this.ws_controller(evt.data, redirectUrl);
      let evtDataToken = JSON.parse(evt.data).token;

      if(evtDataToken) {        
        localStorage.setItem('accessToken' + environment.connId, evtDataToken);
        this.http.post<any>(`${environment.apiUrl}/auth/connect/${environment.connId}`, {}, {
          headers: {
            'Authorization': `Bearer ${evtDataToken}`
          }
        }).subscribe({
          next: data => {             
            localStorage.setItem('accessTokenCentral' + environment.connId, data.token);
            document.location = redirectUrl;
          }
        })
      }
    };

    this.socket.onclose = () => {
      this.reconnect(user, wsUrl, redirectUrl);
    };

    this.socket.onerror = () => {
      console.error('WebSocket error');
    };
  }

  close(): void {
    this.socket.close();
  }

  private ws_controller(data: string, redirectUrl: string = ''): void {
    if(data == 'NEXT') {
      document.location = redirectUrl;
      this.router.navigate([redirectUrl]);
    }
  }

  private reconnect(user: string, wsUrl: string, redirectUrl: string = ''): void {
    setTimeout(() => {
      this.connect(user, wsUrl, redirectUrl);
    }, 0);
  }
}